{
  "dismiss": "Отхвърляне"
}
